<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>관리자 메뉴</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">관리자 메뉴</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">팝업/배너관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
            <li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
            <li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
            <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
            <li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">팝업관리</p>
          <ul class="depth">
            <li><router-link to="/popuplist" title="팝업관리">팝업관리</router-link></li>
            <li><router-link to="/bannerlist" title="배너관리">배너관리</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">팝업 등록</h3>
        <article>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                팝업 등록 테이블
              </caption>
              <colgroup>
                <col style="width: 15%" />
                <col style="width: 35%" />
                <col style="width: 15%" />
                <col style="width: 35%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">제목<span class="redDot">*</span></th>
                  <td colspan="3">
                    <input type="text" title="제목 입력" v-model="title" />
                    <div class="error" v-if="!$v.title.required">필수 입력란입니다.</div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">게시기간<span class="redDot">*</span></th>
                  <td colspan="3">
                    <date-picker :propsDate="searchDate" class="middle"></date-picker>
                  </td>
                </tr>
                <tr>
                  <th scope="row">사용여부</th>
                  <td>
                    <div class="radioGroup">
                      <p class="radio">
                        <input
                          type="radio"
                          id="radio-01"
                          name="radio"
                          class="hidden"
                          v-model="useYn"
                          value="Y"
                          checked
                        />
                        <label for="radio-01">사용함</label>
                      </p>
                      <p class="radio">
                        <input type="radio" id="radio-02" name="radio" class="hidden" v-model="useYn" value="N" />
                        <label for="radio-02">사용안함</label>
                      </p>
                    </div>
                  </td>
                  <th scope="row">위치</th>
                  <td>
                    <div class="flex">
                      <div class="col">
                        <span>X</span>
                        <input type="text" title="가로 위치 입력" class="sm" v-model="posX" @blur="setProps" />
                      </div>
                      <div class="col">
                        <span>Y</span>
                        <input type="text" title="세로 위치 입력" class="sm" v-model="posY" @blur="setProps" />
                      </div>
                      <div class="error" v-if="!$v.posX.required || !$v.posY.required">필수 입력란입니다.</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">크기</th>
                  <td colspan="3">
                    <div class="flex">
                      <div class="col">
                        <span>가로</span>
                        <input type="text" title="가로 길이 입력" class="sm" v-model="sizeY" @blur="setProps" />
                      </div>
                      <div class="col">
                        <span>세로</span>
                        <input type="text" title="세로 길이 입력" class="sm" v-model="sizeX" @blur="setProps" />
                      </div>
                      <div class="error" v-if="!$v.sizeX.required || !$v.sizeY.required">필수 입력란입니다.</div>
                      <div class="error" v-if="!$v.sizeY.between">가로값은 640을 넘게 하지 말아주세요.</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">링크주소<span class="redDot">*</span></th>
                  <td colspan="3">
                    <input type="text" title="링크주소 입력" class="middle" v-model="linkUrl" @blur="setProps" />
                    <p class="info">링크가 없을 경우 공백으로 작성해주세요</p>
                  </td>
                </tr>
                <tr>
                  <th scope="row">팝업내용<span class="redDot">*</span></th>
                  <td colspan="3">
                    <ckeditor :editor="editor" v-model="contents" :config="editorConfig" @ready="onReady"></ckeditor>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--table-->
        </article>
        <article class="btnArea">
          <button class="btn border" @click="$router.push('popuplist')">목록</button>
          <button class="btn gray" @click="popupPreview">미리보기</button>
          <button class="btn blue" @click="insertBtn">저장</button>
        </article>
      </div>
    </section>

    <!-- 미리보기 -->
    <popup v-if="showModal">
      <template #info> {{ title }} </template>
      <template #content>
        <article><p v-html="contents"></p></article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CloseBtn"><span class="hidden">닫기</span></button>
      </template>
    </popup>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import DatePicker from '../../../components/DatePicker2.vue';
import Popup from '../../../components/PopupType1.vue';
import { required, between } from 'vuelidate/lib/validators';
import moment from 'moment';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/ko';
const uploadAdapter = require('../../../assets/js/UploadAdapter');

export default {
  data() {
    return {
      showModal: false,
      firstName: '파일명',

      posX: '500',
      posY: '1000',
      sizeX: '540',
      sizeY: '540',
      title: '',
      useYn: 'Y',
      eFiles: '',
      linkUrl: '',
      contents: '',
      popupImage: '',
      searchDate: {
        startDate: moment(new Date()).format('YYYY-MM-DD'),
        endDate: moment(new Date()).format('YYYY-MM-DD'),
      },
      propsDataArr: {
        posX: '',
        posY: '',
        sizeX: '',
        sizeY: '',
        popupImage: '',
        linkUrl: '',
      },

      editor: ClassicEditor,
      editorConfig: {
        language: 'ko',
        enterMode: 2,
        shiftEnterMode: 3,
        extraPlugins: [uploadAdapter.MyCustomUploadAdapterPlugin],
        mediaEmbed: { previewsInData: true },
      },
    };
  },

  validations: {
    title: {
      required,
    },
    useYn: {
      required,
    },
    posX: {
      required,
    },
    posY: {
      required,
    },
    sizeX: {
      required,
    },
    sizeY: {
      required,
      between: between(0, 640),
    },
  },

  components: {
    DatePicker,
    Popup,
  },

  mounted() {},

  methods: {
    onReady(editor) {
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    },

    setProps() {
      this.propsDataArr.posX = this.posX;
      this.propsDataArr.posY = this.posY;
      this.propsDataArr.sizeX = this.sizeX;
      this.propsDataArr.sizeY = this.sizeY;
      this.propsDataArr.popupImage = this.popupImage;
      this.propsDataArr.linkUrl = this.linkUrl;
    },

    CancleBtn() {
      this.showModal = false;
    },

    CloseBtn() {
      this.showModal = false;
    },

    popupPreview() {
      if (this.posX === '' || this.posY === '' || this.sizeX === '' || this.sizeY === '') {
        alert('위치, 크기를 입력하여주세요.');
        return null;
      }
      this.showModal = true;
    },

    async insertBtn() {
      if (this.$v.$invalid) {
        alert('필수값 확인');
        return;
      }
      const apiParams = new FormData();
      apiParams.append('title', this.title);
      apiParams.append('openDateString', this.searchDate.startDate);
      apiParams.append('closeDateString', this.searchDate.endDate + ' 23:59:59');
      apiParams.append('useYn', this.useYn);
      apiParams.append('posX', this.posX);
      apiParams.append('posY', this.posY);
      apiParams.append('sizeX', this.sizeX);
      apiParams.append('sizeY', this.sizeY);
      apiParams.append('linkUrl', this.linkUrl);
      apiParams.append('popupContents', this.contents);

      const res = await axios('post', '/api/admin/popup/insertAction.json', apiParams);
      const message = res.data.message;
      alert(message);
      this.$router.push('popuplist');
    },
  },
};
</script>
